import React, { useEffect, useState } from 'react';
import { TextField, Button, Typography, IconButton, Grid, FormControl, InputLabel, Select, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio, Autocomplete, Box, Paper, Card, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useForm, Controller, FormProvider } from 'react-hook-form';
import Swal from "sweetalert2";
import ImgUploadDialog from "../../components/ImgUpload/imgUpload";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { CrudServices } from "./CrudServices";
import { isMobile } from "react-device-detect";
import { BookingService } from "../Booking/Service";
import { Helpers } from '../../services/Helpers';
import Loading from '../../components/Loader/Loading';
import TextEditor from '../../utils/QuillTextEditor';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import { PermissionGuard } from '../../components/PermissionGuard';
import { ArrowBack } from '@mui/icons-material';
import { BrandServices } from '../Brand/BrandServices';


const AddService = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const serviceInitialState = {
        title: '',
        shortTitle: '',
        // shortDescription:'',
        description: '',
        image: '',
        categoryId: '',
        serviceCategoryId: '',
        parentServiceId: 0,
        serviceType: 'parent',
        sacId: '',
        selectedBrands:[],

    };

    const [serviceData, setServiceData] = useState(serviceInitialState)

    const serviceFormMethod = useForm({
        mode: "onChange",
        defaultValues: serviceData
    });
    const { register, control, handleSubmit, reset, setValue, watch, formState: { errors, isDirty, dirtyFields } } = serviceFormMethod;

    const [errorMsg, setErrorMsg] = useState("");
    const [modalTitle, setModalTitle] = useState("Add Service");

    const [imageUploadResponseDetails, setImageUploadResponseDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [categoryList, setCategoryList] = useState([]);
    const [sacList, setSacList] = useState([]);
    const fetchSacList = async () => {
        try {
            const response = await CrudServices.fetchSacCodes();
            console.log("response", response);
            if (response.success == '1') {
                setSacList(response.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }


    const fetchCategoryList = async () => {
        try {
            const categoryListResponse = await BookingService.categoryList();
            //   console.log("category list Response:",categoryListResponse);
            if (categoryListResponse.success === 1) {
                setCategoryList(categoryListResponse.data)
            }
        } catch (error) {

        }
    }

    const [brandList,setBrandList] = useState([]);
    const [fetchingBrandList,setFetchingBrandList] = useState(false);

    const fetchBrandList = async ()=>{
        console.log("fetching brand list")
        setFetchingBrandList(true);
        try {
            const brandFetchResponse = await BrandServices.allBrandList();
            if (brandFetchResponse.success == '1') {
                setBrandList(brandFetchResponse.data.list);
            }else if (brandFetchResponse.success == '0'){
                setBrandList([]);
            }
        } catch (error) {
            console.log("error in fetching Brand List:",error)
        }finally{
            setFetchingBrandList(false);
        }
    }

    const fetchServiceData = async () => {
        setIsLoading(true);
        try {
            const serviceDataResponse = await CrudServices.fetchServiceData(id);
            // console.log("service data Response:",serviceDataResponse);
            if (serviceDataResponse.success == '1') {
                const rowData = serviceDataResponse.data;
                const formattedData = {
                    id: rowData?.id,
                    title: rowData.title,
                    shortTitle: rowData.shortTitle,
                    shortDescription: rowData?.shortDescription,
                    description: rowData.description,
                    image: rowData.images,
                    categoryId: rowData?.ServiceCategoryRels[0]?.ServiceCategory.parentId,
                    serviceCategoryId: rowData?.ServiceCategoryRels[0]?.serviceCategoryId,
                    parentServiceId: rowData.parentServiceId,
                    sacId: rowData.sacId,
                    serviceType: rowData.parentServiceId > 0 ? 'child' : 'parent',
                    selectedBrands:rowData.brands?(rowData.brands).map(brand=>brand.brandId):[],
                };
                setServiceData(formattedData);
                // Reset form with the new data and mark as pristine
                reset(formattedData, { isDirty: false });

                // if (formattedData.parentServiceId > 0) {
                //     setValue('serviceType', 'child', { shouldDirty: false });
                //     setValue('categoryId', formattedData.categoryId, { shouldDirty: false });
                //     setValue('serviceCategoryId', formattedData.serviceCategoryId, { shouldDirty: false });
                // }
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }

    /*================= on component load==================== */

    useEffect(() => {
        fetchSacList()
        fetchCategoryList();
        fetchBrandList();
        if (id > 0) {
            fetchServiceData();
            setModalTitle("Edit Service");
        }
    }, []);
    /*================= on category selection==================== */
    const [isLoadingSubCategory, setIsLoadingSubCategory] = useState(false);
    const [subCategoryList, setSubCategoryList] = useState([]);
    const categoryId = watch('categoryId');
    const fetchSubCategoryList = async () => {
        setIsLoadingSubCategory(true);
        try {
            const subCategoryListResponse = await BookingService.subCategoryList({ categoryId: categoryId });
            //   console.log("sub category list Response:",subCategoryListResponse);
            if (subCategoryListResponse.success === 1) {
                setSubCategoryList(subCategoryListResponse.data)
            }
        } catch (error) {

        } finally {
            setIsLoadingSubCategory(false);
        }
    }
    useEffect(() => {
        if (categoryId) {
            fetchSubCategoryList();
        }
    }, [categoryId])
    /*============== on SubCategory selection ============ */
    const subCategoryId = watch('serviceCategoryId');
    const serviceType = watch('serviceType', 'parent');
    const [parentServices, setParentServices] = useState([]);
    const [isLoadingServiceList, setIsLoadingServiceList] = useState(false);
    useEffect(() => {
        if (subCategoryId && serviceType == 'child') {
            // setValue('parentServiceId',0)
            setParentServices([]);
            const fetchServiceList = async () => {
                setIsLoadingServiceList(true);
                try {
                    const serviceListResponse = await CrudServices.serviceListBySubCategory(subCategoryId);
                    // console.log("service list Response:",serviceListResponse);
                    if (serviceListResponse.success === 1) {
                        setParentServices(serviceListResponse.data)
                    }
                } catch (error) {

                } finally {
                    setIsLoadingServiceList(false);
                }
            }
            fetchServiceList();
        }
    }, [subCategoryId, serviceType])

    const onSubmit = (data) => {
        setIsSubmitting(true);
        // list of dirtyFields
        console.log("dirty fields:", dirtyFields);

        // console.log("raw data:",data);
        const modifiedData = {
            title: data.title,
            shortTitle: data.shortTitle,
            // shortDescription: data.shortDescription,
            description: data.description,
            image: data.image,
            serviceCategoryId: data.serviceCategoryId,
            parentServiceId: serviceType == 'parent' ? 0 : data.parentServiceId,
            sacId: data.sacId,
            selectedBrands: data.selectedBrands || [],
        }
        const createRow = async () => {
            setErrorMsg("");
            let createRowRes = "";
            if (serviceData.id > 0) {
                if (isDirty) {
                    // Filter out only the modified fields
                    const modifiedFields = Object.keys(dirtyFields).reduce((acc, key) => {
                        if (modifiedData.hasOwnProperty(key)) {
                            acc[key] = modifiedData[key];
                        }
                        return acc;
                    }, {});
                    // console.log("modified fields",modifiedFields)
                    // Always include title in the final data
                    if (!modifiedFields.hasOwnProperty('title')) {
                        modifiedFields.title = modifiedData.title;
                    }
                    // console.log('Modified fields:', modifiedFields);
                    createRowRes = await CrudServices.updateService(serviceData.id, modifiedFields);
                    // console.log("service update response:",createRowRes)
                }

            } else {
                // console.log("data to be submitted for creating new:",modifiedData)
                createRowRes = await CrudServices.addService(modifiedData)
                // console.log("service create response:",createRowRes)
            }

            if (createRowRes.success == '1') {
                Swal.fire(serviceData.id > 0 ? 'Service Data Updated Successfully' : createRowRes.message, '', 'success')
                if (serviceData.id > 0) {
                    fetchServiceData();
                } else {
                    reset(serviceInitialState);
                    setImageUploadResponseDetails({});
                }
                // closeEvent();
                setIsSubmitting(false);

            } else {
                setErrorMsg(createRowRes.message);
                setIsSubmitting(false)
            }
        }
        createRow();
    }
    /*================== image upload realted ====================== */

    const [imgModalOpen, setImgModalOpen] = useState(false);

    const openImgModal = () => {
        setImgModalOpen(true);
    };

    const closeModal = () => {
        setImgModalOpen(false);
        // afterAddPop(1);
    };

    const imgData = {
        path: 'service',
        img_type: "single"
    };
    const imgUploadResponse = (data) => {
        setImageUploadResponseDetails(data);
        setValue('image', data.imageName, { shouldDirty: true, shouldValidate: true });
    }
    return (
        <>
            {isLoading && <Loading />}
            <PageHeaderLayout headerTitle={modalTitle}>
                <Button variant='contained'
                    onClick={() => navigate(-1)}
                    sx={{ height: "30px", marginTop: "10px" }} startIcon={<ArrowBack />}
                >
                    Back
                </Button>
            </PageHeaderLayout>
            <FormProvider {...serviceFormMethod}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={8}>
                        <Card sx={{ p: 2 }}>
                            <Grid container spacing={1} >
                                {isLoading || isSubmitting && <Loading />}
                                <Grid item xs={12} >
                                    <Grid container spacing={5}>
                                        <Grid item sx={{ pt: '5%!important', display: {xs:'block',sm:'flex'}, alignItems: 'center',gap:1 }} xs={12}>
                                            <Typography sx={{ fontSize: '0.85rem', mt:{xs:'2%',sm:'0'},fontWeight: 600, width: 'fit-content', minWidth:{xs:'45%',sm:'0'} }}>Service Type <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box> :</Typography>

                                            <FormControl component="fieldset">
                                                <Controller
                                                    name="serviceType"
                                                    control={control}
                                                    defaultValue={watch('parentServiceId') == 0 ? 'parent' : 'child'}
                                                    rules={{ required: 'Please select a service type' }}
                                                    render={({ field }) => (
                                                        <RadioGroup {...field} row>
                                                            <FormControlLabel
                                                                value="parent"
                                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }} />}
                                                                label="Parent Service"
                                                                sx={{
                                                                    '& .MuiFormControlLabel-label': {
                                                                        fontSize: '0.75rem'
                                                                    }
                                                                }}
                                                            />
                                                            <FormControlLabel
                                                                value="child"
                                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }} />}
                                                                label="Child Service"
                                                                sx={{
                                                                    '& .MuiFormControlLabel-label': {
                                                                        fontSize: '0.75rem'
                                                                    }
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item sx={{ pt: '1%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Select Category <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                                            <Controller
                                                control={control}
                                                name="categoryId"
                                                rules={{
                                                    required: 'select category',
                                                }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <FormControl sx={{ minWidth: "100%" }} size="small">
                                                        <Select
                                                            {...field}
                                                            error={!!error}
                                                            sx={{
                                                                fontSize: '0.75rem',
                                                            }}
                                                        >
                                                            {
                                                                categoryList.map((category, catIndex) => (
                                                                    <MenuItem value={category.id} sx={{ textTransform: 'capitalize', fontSize: '0.75rem' }} key={catIndex}>{category.title}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item sx={{ pt: '1%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: !categoryId && 'lightGray' }}>Select Sub Category <Box component={'span'} sx={{ color: !categoryId ? 'lightGray' : '#d32f2f' }}>*</Box></Typography>
                                            <Controller
                                                control={control}
                                                name="serviceCategoryId"
                                                rules={{
                                                    required: 'Select Sub Category',
                                                }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <FormControl sx={{ minWidth: "100%" }} size="small">
                                                        <Select
                                                            {...field}
                                                            disabled={!categoryId}
                                                            error={!!error}
                                                            sx={{
                                                                fontSize: '0.75rem',
                                                            }}
                                                        >
                                                            {
                                                                subCategoryList.map((subCategory, subCatIndex) => (
                                                                    <MenuItem value={subCategory.id} sx={{ textTransform: 'capitalize', fontSize: '0.75rem' }} key={subCatIndex}>{subCategory.title}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item sx={{ pt: '2%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Select SAC Code <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                                            <Controller
                                                control={control}
                                                name="sacId"
                                                rules={{
                                                    required: 'Select SAC code',
                                                }}
                                                render={({ field, fieldState: { error } }) => (
                                                    // <FormControl sx={{ minWidth: "100%" }} size="small">
                                                    //     <Select
                                                    //         {...field}
                                                    //         disabled={!subCategoryId}
                                                    //         error={!!error}
                                                    //         sx={{
                                                    //             fontSize:'0.75rem',
                                                    //         }}
                                                    //     >
                                                    //     {
                                                    //     sacList.length>0 && sacList.map((item,sacKey)=>(
                                                    //         <MenuItem value={item.id} sx={{textTransform:'capitalize',fontSize:'0.75rem'}} key={sacKey}>{item.sac}</MenuItem>
                                                    //         ))
                                                    //     }
                                                    //     </Select>
                                                    // </FormControl>
                                                    <Autocomplete
                                                        {...field}
                                                        options={sacList}
                                                        getOptionLabel={(option) => option.sac || ''}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option.id === (value?.id || value)
                                                        }
                                                        onChange={(event, newValue) => {
                                                            field.onChange(newValue ? newValue.id : null);
                                                        }}
                                                        value={sacList.find(option => option.id === field.value) || null}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Select SAC Code*"
                                                                placeholder='Search and Select Sac Code'
                                                                error={!!error}
                                                                // helperText={error ? error.message : ''}
                                                                size="small"
                                                                inputProps={{
                                                                    ...params.inputProps,
                                                                    style: { fontSize: '0.75rem' }
                                                                }}
                                                            />
                                                        )}
                                                        renderOption={(props, option) => (
                                                            <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                                {option.sac || ''}
                                                            </MenuItem>
                                                        )}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        {serviceType === 'child' && (
                                            <Grid item sx={{ pt: '2%!important' }} xs={12} sm={6}>
                                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Select Parent Service <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                                                <Controller
                                                    control={control}
                                                    name="parentServiceId"
                                                    rules={{
                                                        validate: (value) => {
                                                            if (serviceType === 'parent') return true;
                                                            return value ? true : 'Please select a Parent service';
                                                        }
                                                    }}
                                                    render={({ field, fieldState: { error } }) => (
                                                        <Autocomplete
                                                            {...field}
                                                            options={parentServices}
                                                            getOptionLabel={(option) => option.title || ''}
                                                            isOptionEqualToValue={(option, value) =>
                                                                option.masterServiceId === (value?.masterServiceId || value)
                                                            }
                                                            onChange={(event, newValue) => {
                                                                field.onChange(newValue ? newValue.masterServiceId : null);
                                                            }}
                                                            value={parentServices.find(option => option.masterServiceId === field.value) || null}
                                                            disabled={!subCategoryId}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    // label="Select Parent Service*"
                                                                    error={!!error}
                                                                    // helperText={error ? error.message : ''}
                                                                    size="small"
                                                                    inputProps={{
                                                                        ...params.inputProps,
                                                                        style: { fontSize: '0.75rem' }
                                                                    }}
                                                                />
                                                            )}
                                                            renderOption={(props, option) => (
                                                                <li {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                                    {option.title || ''}
                                                                </li>
                                                            )}
                                                        />
                                                    )}
                                                />

                                            </Grid>
                                        )}
                                        {serviceType === 'parent' && (
                                            <Grid item sx={{ pt: '2%!important' }} xs={12} sm={6}>
                                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Select Brands</Typography>
                                                {/* Autocomplete with multipleselect feature */}
                                                <Controller
                                                    control={control}
                                                    name="selectedBrands"
                                                    render={({ field, fieldState: { error } }) => (
                                                        <Autocomplete
                                                            {...field}
                                                            multiple
                                                            options={brandList}
                                                            getOptionLabel={(option) => option.title || ''}
                                                            isOptionEqualToValue={(option, value) =>
                                                                option.id === (value?.id || value)
                                                            }
                                                            onChange={(event, newValue) => {
                                                                field.onChange(newValue.map(item => item.id));
                                                            }}
                                                            value={brandList.filter(option => field.value.includes(option.id))}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={!!error}
                                                                    size="small"
                                                                    inputProps={{
                                                                        ...params.inputProps,
                                                                        style: { fontSize: '0.75rem' }
                                                                    }}
                                                                />
                                                            )}
                                                            renderOption={(props, option) => (
                                                                <li {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                                    {option.title || ''}
                                                                </li>
                                                            )}
                                                            renderTags={(selected, getTagProps) =>
                                                                selected.map((option, index) => {
                                                                const { key, ...chipProps } = getTagProps({ index });
                                                                return (
                                                                    <Chip
                                                                    key={key}
                                                                    label={option.title}
                                                                    {...chipProps}
                                                                    size="small"
                                                                    sx={{
                                                                        fontSize: "0.7rem",       // font size
                                                                        px: .2,                    // horizontal padding
                                                                        py: 0.2,                  // vertical padding
                                                                        "& .MuiChip-deleteIcon": {
                                                                        color: "red",           // ❌ delete icon color
                                                                        fontSize: "16px"        // delete icon size
                                                                        }
                                                                    }}
                                                                    />
                                                                );
                                                                })
                                                            }
                                                        />
                                                    )}
                                                />

                                            </Grid>
                                        )}
                                        <Grid item sx={{ pt: '2%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Service Name <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                                            <Controller
                                                control={control}
                                                name="title"
                                                rules={{
                                                    required: 'Service Name is required',
                                                }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField
                                                        {...field}
                                                        // label="Enter Service Name*"
                                                        variant="outlined"
                                                        size="small"
                                                        inputProps={{ style: { fontSize: '0.75rem' } }}
                                                        fullWidth
                                                        error={!!error}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item sx={{ pt: '2%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Service Short Title <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>
                                            <Controller
                                                control={control}
                                                name="shortTitle"
                                                rules={{
                                                    required: 'Service short title is required',
                                                }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField
                                                        {...field}
                                                        // label="Enter Service Short Title*"
                                                        variant="outlined"
                                                        size="small"
                                                        inputProps={{ style: { fontSize: '0.75rem' } }}
                                                        fullWidth
                                                        error={!!error}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        {/* <Grid item sx={{pt:'2%!important',display:'flex',alignItems:'center'}} xs={12} sm={6}>
                                            <Typography sx={{fontSize:'0.85rem',fontWeight:600,width:'40%'}}>Service Short Description <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                                            <Controller
                                                control={control}
                                                name="shortDescription"
                                                rules={{
                                                    required:'short description is required',
                                                }}
                                                render={({field,fieldState:{error}})=>(
                                                    <TextField
                                                        {...field}
                                                        // label="Enter Service Description"
                                                        variant="outlined"
                                                        size="small"
                                                        inputProps={{style:{fontSize:'0.75rem'}}}
                                                        fullWidth 
                                                        error={!!error}
                                                    />
                                                )}
                                            />
                                        </Grid> */}
                                        <Grid item sx={{ pt: '2%!important' }} xs={12}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Service Detailed Description <Box component={'span'} sx={{ color: '#d32f2f' }}>*</Box></Typography>

                                            <TextEditor
                                                fieldName='description'
                                                rules={{ required: 'description field should not be empty' }}
                                                imageFolder='service'
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ p: 3 }}>
                            <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>
                                Service Image <Box component="span" sx={{ color: 'error.main' }}>*</Box>
                            </Typography>

                            <Box sx={{ mb: 2, textAlign: 'center' }}>
                                {(imageUploadResponseDetails.imageName || serviceData.image) && (
                                    <Box sx={{ mb: 2, justifyContent: 'center', boxShadow: '0 0 5px rgba(0,0,0,0.1)' }}>
                                        <img
                                            src={`${Helpers.ImagePathUrl()}/service/md/${imageUploadResponseDetails.imageName || serviceData.image}`}
                                            alt="Service"
                                            style={{ maxWidth: '100%', height: 'auto' }}
                                        />
                                    </Box>
                                )}

                                <Button
                                    onClick={openImgModal}
                                    disabled={isSubmitting}
                                    variant="outlined"
                                    startIcon={<AddToPhotosIcon />}
                                    size="small"
                                    fullWidth
                                >
                                    {imageUploadResponseDetails.imageName || serviceData.image ? 'Change Image' : 'Upload Image'}
                                </Button>
                            </Box>

                            <Controller
                                control={control}
                                name='image'
                                rules={{ required: 'Please upload an image' }}
                                render={({ fieldState: { error } }) => (
                                    error && (
                                        <Typography color="error" variant="caption" display="block" textAlign="center">
                                            {error.message}
                                        </Typography>
                                    )
                                )}
                            />

                            <Box sx={{ mt: 3, textAlign: 'center' }}>
                                <Button
                                    disabled={!isDirty}
                                    onClick={handleSubmit(onSubmit)}
                                    variant="contained"
                                    color="primary"
                                    size='small'
                                    fullWidth
                                >
                                    {serviceData.id > 0 ? 'Update' : 'Save'}
                                </Button>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </FormProvider>

            {/* ============== image upload dialog ============= */}
            <ImgUploadDialog open={imgModalOpen} onClose={closeModal}
                imgData={imgData}
                imgUploadResponse={imgUploadResponse}
            />
        </>
    )
}


export default AddService;
